import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
@Component({
  selector: "app-view-profile-document",
  templateUrl: "./view-profile-document.component.html",
  styleUrls: ["./view-profile-document.component.scss"],
})
export class ViewProfileDocumentComponent implements OnInit {
  activeLang: string = "en";
  constructor(
    public dialogRef: MatDialogRef<ViewProfileDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {}
}
